<!--Controls Section------------------------------------------------------------------------------------------------------------------------------>
<br>
<div class="body">
    <table id="optionsTable">

        <tr><td colspan="2" height="5">&nbsp;</td></tr>

        <tr>
            <td><input class="tableInput" type="text" [value]="fileName" placeholder=" ..." readonly></td>
            <td><button mat-raised-button color="primary" (click)="uploader.click(); batchDescription=''">Open File</button></td>
        </tr>

        <!-- <tr><td><button mat-raised-button color="primary" class="left" [disabled]="disableLoadFile" (click)="submitCsvData();">Load</button></td></tr> -->

    </table>
    <input hidden type="file" #uploader (change)="uploadFile($event)" />
</div>
<!--Table Section------------------------------------------------------------------------------------------------------------------------------>
<div class="tableContainer">
    <div class="responseContainer">
        <app-response-text
            class="page-message"
            [lambdaMessage]="lambdaMessage"
            [lambdaError]="lambdaError">
        </app-response-text>
    </div>

    <app-mat-data-grid
        class="page-data-grid"
        [(dataSource)]="filteredData"
        [displayedColumns]="[
        'ani',
        'agentName',
        'agentEmail',
        'agentType'
        ]"
        [columnNames]="[
        'ANI',
        'Agent Name',
        'Agent Email Address',
        'Agent type'
        ]"
        [columnFormatters]="{'agentType': formatAgentTypeFunction}"
        [pageSizeOptions]="[5, 10, 15]"
        [buttonConfig]="{
        edit: { show: false },
        delete: { show: false },
        create: { show: false }
        }"
  >
  </app-mat-data-grid>

    <div fxLayout fxLayoutAlign="space-between center" fxLayoutGap="10px">
        <button mat-raised-button color="accent" class="spaced-button" (click)="cancelSelectedBatch();" [disabled]="disableProcessBatch">Cancel</button>
        <button mat-raised-button color="primary" class="spaced-button" (click)="processBatch();" [disabled]="disableProcessBatch">Create Users</button>
    </div>

</div>